import { DomHelpers } from '../core/DomHelpers.js';

/**
 * Раскрывающиеся секции фильтра.
 *
 * - Клик по legend переключает wrapper
 * - Авто-раскрытие секций с выбранными значениями (по collectEntries)
 */
class FilterCollapsibleManager {
    /**
     * Создаёт менеджер и подписывается на клики в пределах host.
     */
    constructor(host, domManager, op) {
        this._host = host;
        this._dom = domManager;
        this._op = op;
        this._onClick = (e) => {
            const t = e.target;
            if (!t)
                return;
            const legend = t.closest(this._op.legendSelector);
            if (!legend || !this._host.contains(legend))
                return;
            this.toggleByLegend(legend);
        };
        this._host.addEventListener("click", this._onClick);
    }
    /** Снять обработчики. */
    destroy() {
        this._host.removeEventListener("click", this._onClick);
    }
    /** Первичная гидрация: раскрыть секции с текущими значениями. */
    hydrate() {
        this.expandSectionsWithValues();
    }
    /**
     * Раскрыть секции, где есть значения.
     * Значения определяются штатно через dom.collectEntries().
     */
    expandSectionsWithValues() {
        const entries = this._dom.collectEntries();
        if (!entries || entries.length === 0)
            return;
        const fm = this._dom.collectFieldMap(); // Record<string, FilterFieldMap>
        for (const e of entries) {
            if (!e.value)
                continue;
            const key = e.schema.key;
            const field = fm[key];
            // 2026-04-29: сначала используем реальный узел из fieldMap, fallback нужен только для старых схем.
            const node = field?.sourceElement
                ?? (field?.dataKey
                    ? this._host.querySelector(`[data-key="${field.dataKey}"]`)
                    : null);
            if (!node)
                continue;
            // Поднимаемся до wrapper
            const wrapper = node.closest(this._op.wrapperSelector);
            if (!wrapper)
                continue;
            // Показать wrapper
            wrapper.style.display = "block";
            // Активировать legend
            const legend = wrapper.previousElementSibling;
            if (legend?.matches(this._op.legendSelector)) {
                legend.classList.add(this._op.legendActiveClass);
            }
        }
    }
    /**
     * Переключить секцию по legend.
     */
    toggleByLegend(legend) {
        // todo: А что делал transition?
        legend.classList.add("transition");
        try {
            legend.classList.toggle(this._op.legendActiveClass);
            const wrapper = legend.nextElementSibling;
            if (!wrapper || !wrapper.matches(this._op.wrapperSelector))
                return;
            DomHelpers.slideToggle(wrapper, this._op.animationMs ?? 300);
        }
        finally {
            legend.classList.remove("transition");
        }
    }
}

export { FilterCollapsibleManager };
